import React from "react";

import { FeedbackOnlyText } from "../../../../../components/FeedbackOnlyText";
import { observer } from "mobx-react-lite";
import { ReactComponent as AttentionIcon } from "../../../../../assets/icons/attention.svg";
import { useNavigateCustom } from "../../../../../hooks";
import { useGlobalStore } from "../../../../../contexts/globalStoreContext";

const feedbackText = {
	title: "Algo deu errado na validação do seu número",
	description:
          "Para sua segurança, bloqueamos seu acesso por 3h. Você pode tentar fazer isso de novo mais tarde",
	type: "numberBlocked",
	link: {},
	warnings: [],
	button: {
		primaryButtonText: "Ir pro início",
		secondaryButtonText: "",
	},
};

export const ExceedAttemptsFeedback: React.FC = observer(() => {
	const navigate = useNavigateCustom();
	const { authenticationStore: { steps	} } = useGlobalStore();

	const handleOnClickPrimaryButton = () => {
		steps.setValue([]);
		navigate("/", { replace: true });
	};

	return (
		<FeedbackOnlyText
			data={feedbackText}
			primaryButton={{
				title: feedbackText.button.primaryButtonText,
				onClick: handleOnClickPrimaryButton,
			}}
			icon={{
				icon: AttentionIcon,
				w: 58,
				color: "error",
			}}
		/>
	);
});
